module.exports = __webpack_public_path__ + "assets/b74.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b74.png
// module id = 665
// module chunks = 0